import { render } from "./ClientEditForm.vue?vue&type=template&id=1f4fabe7&scoped=true"
import script from "./ClientEditForm.vue?vue&type=script&lang=js"
export * from "./ClientEditForm.vue?vue&type=script&lang=js"

import "./ClientEditForm.vue?vue&type=style&index=0&id=1f4fabe7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4fabe7"]])

export default __exports__